import { type QueryFunctionContext, skipToken } from '@tanstack/react-query';
import { z } from 'zod';
import { PromotionDetailSection } from '@/promotions/types';

export const getExhibitionInputSchema = z.object({
  id: z.union([z.string(), z.number()]),
});

export const getExhibitionResponseSchema = z.object({
  exhibition: z
    .object({
      id: z.string(),
      title: z.string(),
      endAt: z.string().optional(),
      coverImageUrls: z.array(z.string()),
      details: z.array(
        z.object({
          id: z.string(),
          units: z.string(),
          stickyTab: z.boolean().nullish(),
          sections: z.array(z.custom<PromotionDetailSection>()).nullish(),
        }),
      ),
    })
    .optional(),
  statusCode: z.number().optional(),
});

export type GetExhibitionInput = z.infer<typeof getExhibitionInputSchema>;
export type GetExhibitionResponse = z.infer<typeof getExhibitionResponseSchema>;
export type GetExhibitionApi = (params: {
  input: GetExhibitionInput;
  signal?: AbortSignal;
}) => Promise<GetExhibitionResponse>;

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const createGetExhibitionQueryOptions = ({
  api,
  input,
  skip,
}: {
  api: GetExhibitionApi;
  input: GetExhibitionInput;
  skip?: boolean;
}) => {
  return {
    queryKey: ['getExhibition', input],
    queryFn: skip
      ? skipToken
      : ({ signal }: QueryFunctionContext) => api({ input, signal }),
  } as const;
};
